import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
} from '@angular/core';
import { FullResultsComponent } from '../../full-results.component';
import { ItemHeader } from '@search/interfaces/search.interface';
import { LinkClickEvent } from '@frk/eds-components';
@Component({
  selector: 'ft-full-results-funds',
  templateUrl: './full-results-funds.component.html',
  styleUrls: [
    '../../full-results.component.scss',
    './full-results-funds.component.scss',
  ],
})
export class FullResultsFundsComponent
  extends FullResultsComponent
  implements OnInit, OnChanges {
  @Input() fundHeader: ItemHeader;
  @Input() fundItems: object[]; // TODO set proper type
  @Input() searchTerm: string;

  @Output() viewMoreClickedFunds = new EventEmitter<string>();

  ngOnInit() {
    // do not remove this
    // when removed, it will call parent OnInit and try to get undefined properties, for example 'result'
    // can be refactored when 'result' is set in service, not set from component
  }
  ngOnChanges() {
    // do not remove this
    // when removed, it will call parent OnInit and try to get undefined properties, for example 'result'
    // can be refactored when 'result' is set in service, not set from component
  }
  /**
   *  this may require refactoring
   * there is an issue with inheritance of Output
   * https://github.com/angular/angular/issues/5415
   *
   */
  onViewMore($tabName: string) {
    this.activeTab = $tabName;
    this.viewMoreClickedFunds.emit($tabName);

    // TODO to verify this position after we introduce filters
    // this.clickedElemBottom = document.getElementById($event.target.id).getBoundingClientRect().top + document.documentElement.scrollTop;
  }

  public onLinkClicked(
    event: LinkClickEvent,
    fundData: object,
    contentType: string
  ): void {
    this.trackSelectorItem(event, fundData, contentType);
  }

  public trackSelectorItem(
    event: LinkClickEvent,
    fundData: any,
    contentType: string
  ): void {
    this.analyticsService.trackEvent({
      event: 'select_content',
      detailed_event: 'Select Content',
      event_data: {
        content_type: contentType,
        facets: '',
        index: '',
        link_text: fundData?.fundName,
        link_url: fundData?.fundLink,
        search_category: 'Investment Options',
        search_term: this.searchTerm,
      },
    });
  }
}
